module.exports = __webpack_public_path__ + "components/app-buttons/static/google-play-70ab69477ab372f2da669235bd2d9e23.svg";